export default __webpack_public_path__ + "static/media/reinforced_iron_plate.f8cf2f71.png";